/**
 * Helper para verificar se o tenant atual contém "MBA_" (case-insensitive)
 * @returns {boolean} true se o tenant contém "MBA_", false caso contrário
 */
export const isMBATenant = () => {
  try {
    const tenant = localStorage.getItem('tenant');
    if (!tenant) {
      return false;
    }
    return tenant.toUpperCase().includes('MBA_');
  } catch (error) {
    console.error('Erro ao verificar tenant:', error);
    return false;
  }
};
